import * as Yup from 'yup';
import {CurrencyEnum} from '../../../../enums';

export type EditChargerCostFormType = {
    name: string;
    date: number;
    cost: number;
    amortizedCost: number;
    currency: CurrencyEnum;
    serviceLife: number;
};

export const editChargerCostSchema = Yup.object().shape({
    name: Yup.string().required('schemaRequiredField'),
    date: Yup.number().required('schemaRequiredInstallationDate'),
    cost: Yup.number().required('schemaRequiredCost').moreThan(0, 'schemaRequiredServiceLife'),
    currency: Yup.string(),
    serviceLife: Yup.number()
        .required('schemaRequiredServiceLife')
        .moreThan(0, 'schemaRequiredServiceLife'),
});
